import { render, staticRenderFns } from "./DeliveryIndicator.vue?vue&type=template&id=203ff253&scoped=true"
import script from "./DeliveryIndicator.vue?vue&type=script&lang=js"
export * from "./DeliveryIndicator.vue?vue&type=script&lang=js"
import style0 from "./DeliveryIndicator.vue?vue&type=style&index=0&id=203ff253&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203ff253",
  null
  
)

export default component.exports